<script setup>
import { withQuery } from "ufo";
import moment from "moment-timezone";

moment.tz.setDefault("Asia/Jakarta");

definePage({
  meta: {
    layout: "default",
  },
});
const pageTitle = "Card Holders";

const route = useRoute();
const router = useRouter();

const { data: dataQuery } = await useApi(
  withQuery("/cms/card/holder/" + route.params.id, {
    method: "GET",
  })
);
const data = dataQuery ? dataQuery.value?.data : [];
console.log("data", data);

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "Master Data",
    to: null,
  },
  {
    title: pageTitle,
    to: "/admin/card-holders",
  },
  {
    title: data.holderId,
    to: null,
  },
];

const statuses = [
  {
    title: "Onboarding",
    value: 1,
  },
  {
    title: "In Service",
    value: 2,
  },
  {
    title: "Suspended",
    value: 3,
  },
  {
    title: "Withdrawal",
    value: 4,
  },
];
const genders = [
  {
    title: "Male",
    value: 1,
  },
  {
    title: "Female",
    value: 2,
  },
];
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <h4 class="text-h4 my-4">{{ pageTitle }} Detail</h4>
  <VCard border class="v-card-data" title="Card Holders Information">
    <template #append>
      <div class="d-flex gap-4">
        <VBtn
          :to="{
            path: '/admin/card-holders/update/' + route.params.id,
          }"
          color="primary"
        >
          <VIcon icon="tabler-pencil" start />
          Edit {{ pageTitle }}
        </VBtn>
      </div>
    </template>
    <VTable class="text-no-wrap" density="compact">
      <tbody>
        <tr>
          <td>Holder ID</td>
          <td>{{ data.id }}</td>
        </tr>
        <tr>
          <td>Verified type</td>
          <td>{{ data.verifiedType ? data.verifiedType : null }}</td>
        </tr>
        <tr>
          <td>Verified document ID</td>
          <td>
            {{ data.verifiedDocumentId ? data.verifiedDocumentId : null }}
          </td>
        </tr>
        <tr>
          <td>Number of card</td>
          <td>{{ data.numberOfCard ? data.numberOfCard : null }}</td>
        </tr>
        <tr>
          <td>Number of virtual card</td>
          <td>
            {{ data.numberOfVirtualCard ? data.numberOfVirtualCard : null }}
          </td>
        </tr>
        <tr>
          <td>KYC status</td>
          <td>{{ data.KYCStatus ? data.KYCStatus : null }}</td>
        </tr>
        <tr>
          <td>Status</td>
          <td>
            <AppSelect
              v-model="data.status"
              :items="statuses"
              class="v-select-print"
              readonly
            />
          </td>
        </tr>
        <tr>
          <td>Family name</td>
          <td>{{ data.familyName }}</td>
        </tr>
        <tr>
          <td>Middle name</td>
          <td>{{ data.middleName }}</td>
        </tr>
        <tr>
          <td>Given name</td>
          <td>{{ data.givenName }}</td>
        </tr>
        <tr>
          <td>Postal code</td>
          <td>{{ data.postalCode }}</td>
        </tr>
        <tr>
          <td>Region</td>
          <td>{{ data.region }}</td>
        </tr>
        <tr>
          <td>Address</td>
          <td>{{ data.address }}</td>
        </tr>
        <tr>
          <td>Building name etc.</td>
          <td>{{ data.buildingName }}</td>
        </tr>
        <tr>
          <td>Mobile number</td>
          <td>{{ data.mobileNumber }}</td>
        </tr>
        <tr>
          <td>Email address</td>
          <td>{{ data.email }}</td>
        </tr>
        <tr>
          <td>Date of birth</td>
          <td>
            {{
              data.dateOfBirth ? moment(data.dateOfBirth).format("LL") : null
            }}
          </td>
        </tr>
        <tr>
          <td>Gender</td>
          <td>
            <AppSelect
              v-model="data.gender"
              :items="genders"
              class="v-select-print"
              readonly
            />
          </td>
        </tr>
        <tr>
          <td>Member rank</td>
          <td>{{ data.memberRank }}</td>
        </tr>
        <tr>
          <td>Memo</td>
          <td>{{ data.memo }}</td>
        </tr>
        <tr>
          <td>Last update</td>
          <td>
            {{ data.updatedAt ? moment(data.updatedAt).format("LLL") : null }}
          </td>
        </tr>
      </tbody>
    </VTable>
  </VCard>
  <div class="mx-auto text-center">
    <VBtn
      :to="{ path: '/admin/card-holders' }"
      class="mt-5 mx-auto text-center"
      color="secondary"
    >
      <VIcon icon="tabler-refresh" start />
      Back to {{ pageTitle }} List
    </VBtn>
  </div>
</template>
